<template>
  <div class="books-box white-bg mb-20">
    <h2 class="books-title-box flex items-center">
      <icon :iconName="icon" />
      <p class="books-title bold">{{ title }}</p>
    </h2>

    <nav class="books flex flex-wrap">
      <router-link
        v-for="(book, index) in bookList"
        :key="index"
        :to="`/goods/detail/${book.book_no}`"
        class="book"
      >
        <div class="book-cover-container flex items-center justify-center">
          <img class="book-cover" :src="book.image" :alt="book.name" />
        </div>
        <p class="book-title nowrap f18">
          {{ book.name }}
        </p>
        <p class="book-price main-cl f24">
          <span class="f18">&yen;</span>{{ book.price }}
        </p>
      </router-link>
    </nav>

  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "icon-bianjituijian",
    },
    title: {
      type: String,
      default: "编辑推荐",
    },
    // 书籍列表
    bookList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="less">
// 书籍封面高度
@bookHeight: 232px;

.books-box {
  padding: 0.3rem 0.4rem 0.1rem;
  border-radius: 16px;

  .books-title {
    font-size: 24px;
    color: #333;
  }

  .books {
    padding-top: 0.24rem;
    .book {
      width: 23.5%;
      margin-right: 2%;
      margin-bottom: 0.36rem;
      &:nth-of-type(4n) {
        margin-right: 0;
      }
      // 书籍封面容器
      &-cover-container {
        height: @bookHeight;
      }
      // 书籍名
      &-title {
        color: #000;
        margin: 18px 0 20px;
      }
    }
  }
}

  .book-cover-container {
    height: 2.7rem;
    max-width: 1.9rem;
    object-fit: cover;
    margin: 0 auto;
    img{
      height: 100%;
    }
  }


@media (max-width: 768px) {
  .books-box {
    padding: 0;
    border-radius: 0;
    @boxHeight: 0.92rem;
    .books-title-box {
      padding: 0 0.3rem;
      height: @boxHeight;
      border-bottom: 1px solid #c9d1d3;
      .books-title {
        font-size: 0.32rem;
      }
      .more-link {
        height: @boxHeight;
        line-height: @boxHeight;
        font-size: 0.24rem;
        color: #878787;
        padding-left: 0.3rem;
      }
    }

    .books {
      padding: 0.24rem 0.3rem 0;

      .book-cover-container {
        height: 2.7rem;
        max-width: 1.9rem;
        object-fit: cover;
        margin: 0 auto;
      }

      .book-title {
        font-size: 0.28rem;
        margin: 0.24rem 0;
      }
      // 书籍价格
      .book-price {
        font-size: 0.36rem;
        line-height: 1;
      }
    }
  }

  .books-box .books .book {
    width: 49%;
    margin-right: 2%;
    &:nth-of-type(4n) {
      margin-right: 2%;
    }
    &:nth-of-type(2n) {
      margin-right: 0;
    }
  }
}
</style>
